import { render, staticRenderFns } from "./bjSearch.vue?vue&type=template&id=e36131c2&scoped=true"
import script from "./bjSearch.vue?vue&type=script&lang=js"
export * from "./bjSearch.vue?vue&type=script&lang=js"
import style0 from "./bjSearch.vue?vue&type=style&index=0&id=e36131c2&prod&lang=less"
import style1 from "./bjSearch.vue?vue&type=style&index=1&id=e36131c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36131c2",
  null
  
)

export default component.exports